import React, { useState, useEffect } from 'react';
import { FormularioRespostasModal } from '@components/Modals/Shared/FormularioRespostasModal/Index';
import { useDispatch, useSelector } from 'react-redux';
import { carregarFormularioRespostaProcesso } from '@store/slices/formularios/Processo/formularioRespostaProcessoSlice';
import { makeSelectFormularioRespostaBySolicitacao } from '@store/selectors/formularios/Processo/formularioRespostaProcessoSelector';
import CustomAntdModal from '@components/Modals/Shared/CustomAntdModal/Index';
import ButtonComp from '@components/UI/Button/Index';
import SweetAlert from '@components/Feedback/SweetAlert/Index';
import { FormularioResponderProcessoModal } from '../FormularioResponderProcessoModal/Index';
import { perfisVisitante } from '@utils/auth/perfis';
import { useAppAuth } from '@contexts/AuthContext';

export const FormularioOptionProcessoModal = ({
  idProcesso,
  idSolicitacao,
  idFormularioAssociado,
  formularioModeloInicial,
  formularioRespostaInicial,
}) => {
  
  const dispatch = useDispatch();
  // busca a resposta do formulario associado ao processo e a solicitação
  const selectResposta = makeSelectFormularioRespostaBySolicitacao(idProcesso, idSolicitacao);
  const formularioResposta = useSelector(selectResposta);

  // Carrega resposta inicial apenas no primeiro load
  useEffect(() => {
    if (!formularioResposta && formularioRespostaInicial) {
      dispatch(
        carregarFormularioRespostaProcesso({ idProcesso, idSolicitacao, resposta: formularioRespostaInicial })
      );
    }
  }, [formularioResposta, formularioRespostaInicial, idProcesso, idSolicitacao, dispatch]);

  const { role } = useAppAuth();
  const isVisitante = perfisVisitante.includes(role);

  const formularioJaRespondido = Boolean(formularioResposta?.respostaJson);
  const formularioAssociado = Boolean(formularioJaRespondido?.formularioJson);

  const idFormularioResposta = formularioResposta?.id;

  const [optionsModalOpen, setOptionsModalOpen] = useState(false);
  const [responderVisible, setResponderVisible] = useState(false);
  const [respostasVisible, setRespostasVisible] = useState(false);

  const handleClick = () => {
    if (!formularioModeloInicial) {
      SweetAlert.toastInfo('Nenhum formulário de processo associado.');
      return;
    }
    
    if (isVisitante) {
      if (formularioJaRespondido) {
        setRespostasVisible(true);
      } else {
        SweetAlert.toastInfo('Seu perfil (Visitante) não tem permissão para responder formulários.');
      }
      return;
    }

    setOptionsModalOpen(true);
  };

  return (
    <div>
      <ButtonComp
        title="FORMULÁRIO"
        type="button"
        buttonColor="#2b97be"
        classnameIcon="fa-regular fa-floppy-disk"
        hoverMessage="Abrir opções do formulário do processo"
        onClick={handleClick}
      />
      <CustomAntdModal
        open={optionsModalOpen}
        onCancel={() => setOptionsModalOpen(false)}
        title="Formulário de Processo"
        description={
          formularioJaRespondido
            ? 'Você pode visualizar as respostas do formulário do processo.'
              : 'Você pode responder o formulário do processo.'
        }
      >
        {!isVisitante && !formularioJaRespondido && !formularioAssociado && (
          <ButtonComp
            title="Responder"
            buttonColor="#125578"
            type="button"
            classnameIcon="fa-regular fa-edit"
            hoverMessage="Responder formulário"
            style={{ width: '100%' }}
            onClick={() => { setResponderVisible(true); setOptionsModalOpen(false); }}
          />
        )}
        {formularioJaRespondido && (
          <ButtonComp
            title="Visualizar Respostas"
            buttonColor="#2b97be"
            type="button"
            classnameIcon="fa-regular fa-eye"
            hoverMessage="Visualizar respostas"
            style={{ width: '100%' }}
            onClick={() => { setRespostasVisible(true); setOptionsModalOpen(false); }}
          />
        )}
      </CustomAntdModal>

      <FormularioResponderProcessoModal
        visible={responderVisible}
        onClose={() => setResponderVisible(false)}
        idFormularioAssociado={idFormularioAssociado}
        idSolicitacao={idSolicitacao}
        idProcesso={idProcesso}
      />

      <FormularioRespostasModal
        visible={respostasVisible}
        onClose={() => setRespostasVisible(false)}
        formularioId={idFormularioResposta}
        idSolicitacao={idSolicitacao}
      />
    </div>
  );
};
